var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06154 13.4918L9.23077 11.9998L6.06154 10.5077L4.61538 7.23788L3.16923 10.5077L0 11.9998L3.16923 13.4918L4.61538 16.7617L6.06154 13.4918ZM12.6154 23.1109L11.1692 19.8411L8 18.349L11.1692 16.8569L12.6154 13.5871L14.0615 16.8569L17.2308 18.349L14.0615 19.8411L12.6154 23.1109Z",
    fill: "url(#paint0_linear_5674_133456)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9385 8.17439L14.6154 11.9998L16.2923 8.17439L20 6.44423L16.2923 4.71407L14.6154 0.888672L12.9385 4.71407L9.23077 6.44423L12.9385 8.17439Z",
    fill: "url(#paint1_linear_5674_133456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5674_133456",
    x1: 1.61554,
    y1: 8.11086,
    x2: 26.5127,
    y2: 15.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D662CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5674_133456",
    x1: 1.61554,
    y1: 8.11086,
    x2: 26.5127,
    y2: 15.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5265FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D662CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNlp);
export default __webpack_public_path__ + "static/media/search-nlp.8e3ec855b17416579b9f5bf7a2420df1.svg";
export { ForwardRef as ReactComponent };